<script>
import PasswordResetComponent from '../features/PasswordResetComponent';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'PasswordResetView',
  components: {
        'brand-logo': BrandLogo,},
  mixins: [PasswordResetComponent],
};
</script>

<template>
  <div class="public-page">
    <div class="public-page__background">
      <!-- Left Branding Panel -->
      <div class="public-page__branding">
        <div class="public-page__branding-content">
          <router-link
            to="/"
            class="public-page__logo-link"
          >
            <brand-logo
              variant="light"
              size="lg"
              stacked
            />
          </router-link>
          <div class="public-page__branding-text">
            <h1>Nueva contraseña</h1>
            <p>Elige una contraseña segura para proteger tu cuenta de AppMisionate.</p>
          </div>
        </div>
      </div>

      <!-- Right Form Panel -->
      <div class="public-page__form-panel">
        <div class="public-page__card">
          <!-- Card Header -->
          <div class="public-page__card-header">
            <div class="public-page__card-header-icon">
              <i class="uil uil-lock-open-alt" />
            </div>
            <h2>Cambiar Contraseña</h2>
            <p>Ingresa tu nueva contraseña a continuación</p>
          </div>

          <!-- Form -->
          <el-form
            ref="formData"
            v-loading="isFormProcessing"
            :model="formData"
            :rules="rules"
            status-icon
            :label-position="'top'"
            :element-loading-text="formProcessingMessage"
            class="public-page__form"
          >
            <el-form-item
              label="Nueva Contraseña"
              prop="password"
            >
              <el-input
                v-model="formData.password"
                type="password"
                show-password
                placeholder="Ingresa tu nueva contraseña"
                size="large"
                @keyup.enter="onSend('formData')"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Confirmar Contraseña"
              prop="checkPass"
            >
              <el-input
                v-model="formData.checkPass"
                type="password"
                show-password
                placeholder="Confirma tu nueva contraseña"
                size="large"
                @keyup.enter="onSend('formData')"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <div class="public-page__submit">
              <el-button
                type="primary"
                size="large"
                class="public-page__submit-btn"
                :loading="isFormProcessing"
                @click="onSend('formData')"
              >
                <i class="uil uil-check-circle" />
                Guardar Nueva Contraseña
              </el-button>
            </div>
          </el-form>

          <!-- Footer -->
          <div class="public-page__card-footer">
            <p>
              <router-link to="/login">
                <i class="uil uil-arrow-left" />
                Volver al inicio de sesión
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

